/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface SravniDataNormalizationPagedModel1SravniNewsModelsCommentsBackofficeSravniNewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  items?: SravniNewsModelsCommentsBackoffice[] | null;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  total?: number;
}

export interface SravniDataNormalizationPagedModel1SravniNewsSharedModelsAuthorsAuthorsWithVotesCountModelSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  items?: SravniNewsSharedModelsAuthorsAuthorsWithVotesCountModel[] | null;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  total?: number;
}

export interface SravniDataNormalizationPagedModel1SravniNewsSharedModelsCommentsCommentReadModelSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  items?: SravniNewsSharedModelsCommentsCommentReadModel[] | null;
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  /** @format int32 */
  total?: number;
}

export interface SravniIdentityClientsSubscriptionInfo {
  types?: SravniIdentitySubscriptionType[] | null;
  source?: string | null;
  /** @format date-time */
  date?: string | null;
}

export interface SravniIdentityClientsUser {
  /** @format int32 */
  id?: number;
  username?: string | null;
  /** @format date-time */
  registerDate?: string;
  pseudonym?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  /** @format date-time */
  birthDate?: string | null;
  /** @format int32 */
  companyId?: number | null;
  gender?: SravniIdentityGender;
  locality?: string | null;
  localityRoute?: string | null;
  otac?: string | null;
  phone?: string | null;
  email?: string | null;
  unconfirmedEmail?: string | null;
  subscriptions?: SravniIdentityClientsSubscriptionInfo;
  emailConfirmationToken?: string | null;
  hasPassword?: boolean;
}

export enum SravniIdentityGender {
  Male = 'male',
  Female = 'female',
}

export enum SravniIdentitySubscriptionType {
  CommentsNotifications = 'commentsNotifications',
  OrdersNotifications = 'ordersNotifications',
  News = 'news',
  Targeted = 'targeted',
}

export interface SravniMicroErrorsError {
  code?: string | null;
  target?: string | null;
  message?: string | null;
  description?: string | null;
  attemptedValue?: string | null;
  details?: SravniMicroErrorsError[] | null;
}

export interface SravniMicroErrorsErrorModel {
  error?: SravniMicroErrorsError;
}

export interface SravniNewsDomainAuthorBlock {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  created?: string;
  name?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
  cause?: string | null;
  /** @format int32 */
  blockedBy?: number;
  blockedByContact?: string | null;
  isUnblocked?: boolean;
  /** @format date-time */
  unblockedDate?: string | null;
  /** @format int32 */
  unblockedBy?: number | null;
  unblockedByContact?: string | null;
}

export interface SravniNewsModelsCommentsBackoffice {
  /** @format int64 */
  id?: number;
  /** @format date-time */
  created?: string;
  deleted?: boolean;
  /** @format date-time */
  deletedDate?: string | null;
  /** @format int64 */
  postId?: number;
  /** @format int64 */
  parentId?: number | null;
  text?: string | null;
  /** @format int32 */
  commentsCount?: number;
  /** @format int32 */
  userId?: number;
  userName?: string | null;
  userLastName?: string | null;
  email?: string | null;
  phone?: string | null;
  moderationReason?: SravniNewsSharedEnumsModerationReasonType;
  /** @format int64 */
  likes?: number;
  materialUrl?: string | null;
  moderationReasonTypeName?: string[] | null;
  materialTitle?: string | null;
}

export interface SravniNewsModelsDictionaryDto {
  name?: string | null;
  alias?: string | null;
  value?: string | null;
  iconUrl?: string | null;
}

export interface SravniNewsModelsDictionaryResult {
  items?: SravniNewsModelsDictionaryDto[] | null;
}

export interface SravniNewsModelsHighLigthResultModel {
  items?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  hasMore?: boolean;
}

export enum SravniNewsModelsImportanceDegree {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
}

export interface SravniNewsModelsMaterial {
  /** @format int32 */
  id?: number;
  title?: string | null;
  htmlHead?: string | null;
  htmlBody?: string | null;
  picture?: SravniNewsModelsPicture;
  miniPicture?: SravniNewsModelsPicture;
  targeting?: string | null;
  ogTitle?: string | null;
  ogDescription?: string | null;
  /** @format date-time */
  createDate?: string;
  /** @format date-time */
  lastChangeDate?: string;
  /** @format date-time */
  publishDate?: string;
  alias?: string | null;
  lead?: string | null;
  signature?: string | null;
  authorName?: string | null;
  authorLastName?: string | null;
  rubric?: string | null;
  type?: SravniNewsSharedEnumsMaterialType;
  importance?: SravniNewsModelsImportanceDegree;
  mainOrganizationId?: string | null;
  productTags?: string[] | null;
  taggedOrganizationIds?: number[] | null;
  tags?: string[] | null;
  subTags?: string[] | null;
  seoTitle?: string | null;
  seoDescription?: string | null;
  seoKeywords?: string | null;
  /** @format int64 */
  visits?: number;
  noIndex?: boolean;
  showTableOfContents?: boolean;
  tinkoffInvestmentsTags?: string | null;
  externalLink?: string | null;
  externalId?: string | null;
  /** Тип внешнего материала */
  externalType?: SravniNewsSharedEnumsExternalMaterialType;
  lookButtonText?: string | null;
  passButtonText?: string | null;
  calculateButtonText?: string | null;
  answerButtonText?: string | null;
  templateType?: SravniNewsSharedEnumsMaterialTemplateType;
  isWebflow?: boolean;
  webflowHead?: string | null;
  webflowBody?: string | null;
  advertisingShieldText?: string | null;
  /** @format int32 */
  priorityOnMain?: number;
  /** @format int32 */
  priorityOnList?: number;
  /** @format int32 */
  priorityOnScroll?: number;
  /** @format int32 */
  priorityOnAdditionalReading?: number;
  hideAds?: boolean;
  /** @format int32 */
  commentsCount?: number;
  canCreateNewComments?: boolean;
  projectName?: string | null;
  authors?: SravniNewsSharedModelsAuthorsAuthorReadModel[] | null;
  relationTo?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  organizationData?: SravniOrganizationsSharedOrganizationData;
  /** @format int64 */
  likes?: number;
  isTargetPlacement?: boolean;
  placementTags?: string[] | null;
  placementProductTags?: string[] | null;
  placementSeoContentCategoryTags?: string[] | null;
  placementSeoContentSubCategoryTags?: string[] | null;
  interestingOfferTypes?: string[] | null;
  isEncyclopedia?: boolean;
  isAi?: boolean;
  puid?: string[] | null;
}

export interface SravniNewsModelsPicture {
  url?: string | null;
  /** @format int32 */
  width?: number;
  /** @format int32 */
  height?: number;
}

export interface SravniNewsModelsPlacementConfiguration {
  /** Места подмешивания продвигаемых новостей */
  placementType?: SravniNewsSharedEnumsPlacementType;
  /** @format int32 */
  maxItems?: number;
  materials?: SravniNewsModelsMaterial[] | null;
}

export interface SravniNewsModelsResult1SystemCollectionsGenericList1SravniNewsSharedModelsMaterialsHighLightSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNullSystemPrivateCoreLibVersion8000CultureNeutralPublicKeyToken7Cec85D7Bea7798E {
  items?: SravniNewsSharedModelsMaterialsHighLight[][] | null;
}

export interface SravniNewsModelsRubricDictionaryResult {
  items?: SravniNewsModelsRubricResultModel[] | null;
}

export interface SravniNewsModelsRubricResultModel {
  value?: string | null;
  /** @format int64 */
  id?: number;
  name?: string | null;
  alias?: string | null;
  /** @format int32 */
  menuOrder?: number | null;
  iconUrl?: string | null;
  isPrivate?: boolean;
  isNews?: boolean;
  subDomain?: string | null;
}

export interface SravniNewsModelsTag {
  /** @format int64 */
  id?: number;
  alias?: string | null;
  name?: string | null;
  isPrivate?: boolean;
  isSpecialProjects?: boolean;
}

export interface SravniNewsModelsUserContentReadModel {
  /** @format int64 */
  id?: number;
  /** @format date-time */
  date?: string;
  text?: string | null;
  title?: string | null;
  rubric?: string | null;
  rubricAlias?: string | null;
  /** @format int32 */
  commentsCount?: number;
  /** @format int64 */
  likes?: number;
  picture?: string | null;
  alias?: string | null;
  /** @format date-time */
  publishDate?: string;
  type?: SravniNewsSharedEnumsMaterialType;
}

/** Тип сортировки комментариев */
export enum SravniNewsSharedEnumsCommentsSortBy {
  Date = 'date',
}

export enum SravniNewsSharedEnumsDictionaryType {
  Rubrics = 'rubrics',
  ProductTags = 'productTags',
  Tags = 'tags',
  SubTags = 'subTags',
}

/** Тип внешнего материала */
export enum SravniNewsSharedEnumsExternalMaterialType {
  Unknown = 'unknown',
  Promo = 'promo',
  Qna = 'qna',
}

export enum SravniNewsSharedEnumsMaterialTemplateType {
  Sravni = 'sravni',
  Setka = 'setka',
  LegacyWebFlow = 'legacyWebFlow',
}

export enum SravniNewsSharedEnumsMaterialType {
  Undefined = 'undefined',
  News = 'news',
  Article = 'article',
  PrivateArticle = 'privateArticle',
  PrivateNews = 'privateNews',
}

export enum SravniNewsSharedEnumsModerationReasonType {
  None = 'none',
  EmailContent = 'emailContent',
  PhoneContent = 'phoneContent',
  AbusiveContent = 'abusiveContent',
  Ads = 'ads',
  Spam = 'spam',
  Fraud = 'fraud',
  IncompleteData = 'incompleteData',
  ImageContent = 'imageContent',
  Link = 'link',
  TransliterationContent = 'transliterationContent',
  UnreadableContent = 'unreadableContent',
  ImportedRequiresConfirmation = 'importedRequiresConfirmation',
  InvalidContentMatching = 'invalidContentMatching',
}

/** Места подмешивания продвигаемых новостей */
export enum SravniNewsSharedEnumsPlacementType {
  ArticlesList = 'articlesList',
  HomePage = 'homePage',
  EndlessScroll = 'endlessScroll',
  AdditionalReading = 'additionalReading',
  NewsList = 'newsList',
  UsefulReading = 'usefulReading',
  PartnerMaterials = 'partnerMaterials',
  SpecialProjects = 'specialProjects',
}

/** Тип сортировки экпсертов */
export enum SravniNewsSharedEnumsSortExprertsType {
  Rating = 'rating',
  Materials = 'materials',
}

/** Модель с сертификатами автора */
export interface SravniNewsSharedModelsAuthorCertificateReadModel {
  text?: string | null;
  link?: string | null;
  /** @format int32 */
  position?: number;
}

/** Модель с публикациями автора */
export interface SravniNewsSharedModelsAuthorPublicationsReadModel {
  text?: string | null;
  link?: string | null;
  /** @format int32 */
  position?: number;
  icon?: string | null;
}

/** Модель автора для чтения */
export interface SravniNewsSharedModelsAuthorsAuthorReadModel {
  /**
   * Идентификатор identity
   * @format int64
   */
  id?: number;
  /**
   * Идентификатор WordPress
   * @format int64
   */
  wpId?: number;
  /** Отображаемое имя */
  displayName?: string | null;
  /** Почта */
  email?: string | null;
  /** Описание */
  description?: string | null;
  /** Образование */
  education?: string | null;
  /** Опыт работы */
  workExperience?: string | null;
  /** Facebook */
  facebook?: string | null;
  /** Instagram */
  instagram?: string | null;
  /** Вконтакте */
  vk?: string | null;
  /** Ок */
  ok?: string | null;
  /** Телеграм */
  telegram?: string | null;
  /** Роль */
  title?: string | null;
  /** Является ли автор экспертом */
  isExpert?: boolean;
  /**
   * Возраст
   * @format int32
   */
  age?: number;
  /**
   * Рейтинг автора
   * @format int64
   */
  rating?: number;
  /** Сертификаты автора */
  certificates?: SravniNewsSharedModelsAuthorCertificateReadModel[] | null;
  /** Публикации автора */
  publications?: SravniNewsSharedModelsAuthorPublicationsReadModel[] | null;
  /** Рубрики */
  rubrics?: SravniNewsSharedModelsNameAliasModel[] | null;
  /**
   * Кол-во опубликованных материалов пользователя
   * @format int32
   */
  materialsCount?: number;
  /**
   * Кол-во комментариев пользователя
   * @format int32
   */
  commentsCount?: number;
  /** Фамилия */
  lastName?: string | null;
}

/** Модель для получения авторов с информацией по кол-ву лайков за указанный период */
export interface SravniNewsSharedModelsAuthorsAuthorsWithVotesCountModel {
  /**
   * Идентификатор identity
   * @format int64
   */
  id?: number;
  /**
   * Идентификатор WordPress
   * @format int64
   */
  wpId?: number;
  /** Отображаемое имя */
  displayName?: string | null;
  /** Почта */
  email?: string | null;
  /** Описание */
  description?: string | null;
  /** Образование */
  education?: string | null;
  /** Опыт работы */
  workExperience?: string | null;
  /** Facebook */
  facebook?: string | null;
  /** Instagram */
  instagram?: string | null;
  /** Вконтакте */
  vk?: string | null;
  /** Ок */
  ok?: string | null;
  /** Телеграм */
  telegram?: string | null;
  /** Роль */
  title?: string | null;
  /** Является ли автор экспертом */
  isExpert?: boolean;
  /**
   * Возраст
   * @format int32
   */
  age?: number;
  /**
   * Рейтинг автора
   * @format int64
   */
  rating?: number;
  /** Сертификаты автора */
  certificates?: SravniNewsSharedModelsAuthorCertificateReadModel[] | null;
  /** Публикации автора */
  publications?: SravniNewsSharedModelsAuthorPublicationsReadModel[] | null;
  /**
   * Кол-во опубликованных материалов пользователя
   * @format int32
   */
  materialsCount?: number;
  /**
   * Кол-во комментариев пользователя
   * @format int32
   */
  commentsCount?: number;
  /** Фамилия */
  lastName?: string | null;
  /**
   * Количество голосов за период
   * @format int64
   */
  votesCountForPeriod?: number;
  /**
   * Количество материалов за период
   * @format int32
   */
  materialsCountForPeriod?: number;
}

/** Расширение данных о материале автора */
export interface SravniNewsSharedModelsCommentsAuthorMaterialInfoModel {
  /** @format int64 */
  id?: number;
  alias?: string | null;
  rubricType?: string | null;
  rubric?: string | null;
  tags?: string[] | null;
  organizationId?: string | null;
  externalUrl?: string | null;
  type?: SravniNewsSharedEnumsMaterialType;
  /**
   * Дата публикации
   * @format date-time
   */
  publishDate?: string;
}

/** Модель комментария для чтения */
export interface SravniNewsSharedModelsCommentsCommentReadModel {
  /**
   * Идентификатор комментария
   * @format int64
   */
  id?: number;
  /**
   * Дата создания комментария
   * @format date-time
   */
  created?: string;
  /**
   * Идентификатор статьи
   * @format int64
   */
  postId?: number;
  /**
   * Идентификатор родительского комментария
   * @format int64
   */
  parentId?: number | null;
  /** Текст комментария */
  text?: string | null;
  /**
   * Идентификатор пользователя
   * @format int32
   */
  userId?: number;
  /** Никнейм пользователя */
  userName?: string | null;
  /** Фамилия пользователя */
  userLastName?: string | null;
  /** Почта пользователя */
  email?: string | null;
  /** Телефон пользователя */
  phone?: string | null;
  /**
   * Кол-во вложенных комментариев
   * @format int32
   */
  commentsCount?: number;
  /** Статус премодерации */
  moderationReasons?: SravniNewsSharedEnumsModerationReasonType[] | null;
  /**
   * Кол-во лайков
   * @format int64
   */
  likes?: number;
  /** Может пользователь редактировать комментарий или нет */
  canEdit?: boolean;
  /** Может пользователь удалить комментарий или нет */
  canDelete?: boolean;
  /** Признак говорит, лайкнул текущий пользователь комментарий или нет */
  isLiked?: boolean;
  /** Расширение данных о материале автора */
  materialInfo?: SravniNewsSharedModelsCommentsAuthorMaterialInfoModel;
}

/** Модель создания/обновления комментария */
export interface SravniNewsSharedModelsCommentsCommentUpdateModel {
  /**
   * Идентификатор материала
   * @format int64
   */
  postId?: number;
  /**
   * Идентификатор родительского комментария
   * @format int64
   */
  parentId?: number | null;
  /** Текст комментария */
  text?: string | null;
}

/** Модель с кол-вом комментариев */
export interface SravniNewsSharedModelsCommentsPostCommentsCount {
  /**
   * Идентификатор материала
   * @format int64
   */
  postId?: number;
  /**
   * Кол-во комментариев
   * @format int32
   */
  commentsCount?: number;
}

/** Модель с кол-вом лайков */
export interface SravniNewsSharedModelsCommentsPostLikesCount {
  /**
   * Идентификатор материала
   * @format int64
   */
  postId?: number;
  /**
   * Кол-во лайков
   * @format int32
   */
  likesCount?: number;
}

/** Информация об одном голосе пользователя */
export interface SravniNewsSharedModelsLikesLikeInfo {
  /**
   * Идентификатор статьи или комментария
   * @format int64
   */
  targetId?: number;
  /** Голос за - true, против - false */
  like?: boolean;
}

export interface SravniNewsSharedModelsLikesLikeUpdateModel {
  /**
   * Идентификатор поста
   * @format int64
   * @min 0
   * @max 2147483647
   */
  postId?: number;
  /**
   * Идентификатор коммента, 0 если лайк присвоен исключительно посту
   * @format int64
   * @min 0
   * @max 2147483647
   */
  entityId?: number;
  /** FP пользователя */
  fingerPrint?: string | null;
}

/** Информация о лайках пользователя */
export interface SravniNewsSharedModelsLikesUserLikesResult {
  /** Лайки пользователя в статьях */
  materials?: SravniNewsSharedModelsLikesLikeInfo[] | null;
  /** Лайки пользователя в комментариях */
  comments?: SravniNewsSharedModelsLikesLikeInfo[] | null;
}

export interface SravniNewsSharedModelsLimitModel1SravniNewsSharedModelsMaterialsHighLightSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  total?: number;
  items?: SravniNewsSharedModelsMaterialsHighLight[] | null;
}

/** Те поля сущности Материал, которые нужны для выдачи материалов */
export interface SravniNewsSharedModelsMaterialsHighLight {
  /** @format int32 */
  id?: number;
  /** Рубрика */
  rubric?: string | null;
  type?: SravniNewsSharedEnumsMaterialType;
  /** Заголовок */
  title?: string | null;
  /** Алиас */
  alias?: string | null;
  /** Лид */
  lead?: string | null;
  /** Относительная ссылка на миникартинку */
  miniPicture?: string | null;
  /**
   * Количество просмотров
   * @format int64
   */
  views?: number;
  /**
   * Дата публикации
   * @format date-time
   */
  pubDate?: string;
  /** Ставить noIndex? */
  noIndex?: boolean;
  body?: string | null;
  url?: string | null;
  isExternal?: boolean;
  /** Идентификатор внешнего материала, если есть */
  externalId?: string | null;
  /** Тип внешнего материала */
  externalType?: SravniNewsSharedEnumsExternalMaterialType;
  /**
   * Кол-во комментариев
   * @format int32
   */
  commentsCount?: number;
  /** Псевдоним автора */
  authorName?: string | null;
  /** Фамилия автора */
  authorLastName?: string | null;
  /** Общие теги */
  tags?: string[] | null;
  organizationData?: SravniOrganizationsSharedOrganizationData;
  /**
   * Приоритет на главной. Чем больше число, тем выше находится статья
   * @format int32
   */
  priorityOnMain?: number;
  /**
   * Приоритет на главной. Чем больше число, тем выше находится статья
   * @format int32
   */
  priorityOnList?: number;
  /**
   * Приоритет на главной. Чем больше число, тем выше находится статья
   * @format int32
   */
  priorityOnScroll?: number;
  /**
   * Приоритет на главной. Чем больше число, тем выше находится статья
   * @format int32
   */
  priorityOnAdditionalReading?: number;
  /**
   * Кол-во лайков
   * @format int64
   */
  likes?: number;
  /** Puid */
  puid?: string[] | null;
}

export interface SravniNewsSharedModelsMaterialsMaterialInfoModel {
  /** @format int64 */
  id?: number;
  alias?: string | null;
  rubricType?: string | null;
  rubric?: string | null;
  tags?: string[] | null;
  organizationId?: string | null;
  externalUrl?: string | null;
  type?: SravniNewsSharedEnumsMaterialType;
}

export interface SravniNewsSharedModelsMaterialsMaterialsInfoModel {
  /** @format date-time */
  publishDate?: string;
  items?: SravniNewsSharedModelsMaterialsMaterialInfoModel[] | null;
}

export enum SravniNewsSharedModelsMaterialsOrderBy {
  PublishDate = 'publishDate',
  Visits = 'visits',
}

/** Эксперимент для главной сайта топ просмотренных за последнюю неделю, самые свежие */
export interface SravniNewsSharedModelsMaterialsTopFreshHighLights {
  /** Топ */
  tops?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  /** Средние */
  mids?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  /** Начинающие */
  juniors?: SravniNewsSharedModelsMaterialsHighLight[] | null;
}

/** Модель тегов для чтения */
export interface SravniNewsSharedModelsNameAliasModel {
  /**
   * идентификатор тега
   * @format int64
   */
  id?: number;
  /** Наименование */
  name?: string | null;
  /** Алиас */
  alias?: string | null;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsDomainAuthorBlockSravniNewsDomainVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsDomainAuthorBlock[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsModelsMaterialSravniNewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsModelsMaterial[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsModelsUserContentReadModelSravniNewsModelsVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsModelsUserContentReadModel[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsSharedModelsCommentsCommentReadModelSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsSharedModelsCommentsCommentReadModel[] | null;
  /** @format int32 */
  total?: number;
}

export interface SravniNewsSharedModelsPageModel1SravniNewsSharedModelsMaterialsHighLightSravniNewsSharedVersion1000CultureNeutralPublicKeyTokenNull {
  /** @format int32 */
  pageIndex?: number;
  /** @format int32 */
  pageSize?: number;
  items?: SravniNewsSharedModelsMaterialsHighLight[] | null;
  /** @format int32 */
  total?: number;
}

/** Информация о количестве отзывов у поста */
export interface SravniNewsSharedModelsViewsViewInfo {
  /**
   * Идентификатор поста
   * @format int64
   */
  targetId?: number;
  /**
   * Количество просмотров
   * @format int64
   */
  views?: number;
}

export interface SravniOrganizationsSharedOrganizationData {
  id?: string | null;
  mongoId?: string | null;
  /** @format int32 */
  oldId?: number | null;
  organizationType?: SravniOrganizationsSharedReviewObjectType;
  alias?: string | null;
  status?: SravniOrganizationsSharedOrganizationStatus;
  name?: string | null;
  deleted?: boolean;
  isRecomended?: boolean | null;
  type?: SravniOrganizationsSharedOrganizationType;
  logotype?: string | null;
}

export enum SravniOrganizationsSharedOrganizationStatus {
  Absorbed = 'absorbed',
  Active = 'active',
  Archived = 'archived',
  Hidden = 'hidden',
}

export enum SravniOrganizationsSharedOrganizationType {
  Unknown = 'unknown',
  Bank = 'bank',
  Insurance = 'insurance',
  Mfo = 'mfo',
  EducationalOrganization = 'educationalOrganization',
  Broker = 'broker',
  Npf = 'npf',
  Leasing = 'leasing',
  Marketplace = 'marketplace',
  Bankruptcy = 'bankruptcy',
  University = 'university',
  Bookmaker = 'bookmaker',
  Investment = 'investment',
  NonbankingOrganization = 'nonbankingOrganization',
  MortgageAgent = 'mortgageAgent',
  Other = 'other',
  FoodRation = 'foodRation',
}

export enum SravniOrganizationsSharedReviewObjectType {
  Unknown = 'unknown',
  Banks = 'banks',
  InsuranceCompany = 'insuranceCompany',
  CarService = 'carService',
  CarModel = 'carModel',
  Mfi = 'mfi',
  EducationalOrganization = 'educationalOrganization',
  Broker = 'broker',
  Npf = 'npf',
  Leasing = 'leasing',
  Marketplace = 'marketplace',
  Bankruptcy = 'bankruptcy',
  University = 'university',
  Bookmaker = 'bookmaker',
  Investment = 'investment',
  FoodRation = 'foodRation',
}

export interface MaterialsAuthorsListParams {
  /** Имя */
  DisplayName?: string;
  /** Вернуть данные автора с его рейтингом или нет */
  IncludeRating?: boolean;
  /** Вернуть редакторов (true), обычных пользователей (false), обоих (null) */
  IsEditor?: boolean;
}

export interface AuthorGetIdentityUserListParams {
  email?: string;
  phone?: string;
}

export interface AuthorCheckInIdentityListParams {
  email?: string;
  phone?: string;
}

export interface AuthorsBlocksListParams {
  /** @format int64 */
  AuthorId?: number;
  Term?: string;
  IsBlocked?: boolean;
  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;
  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
}

export interface AuthorBlockCreateParams {
  /**
   * Причина блокировки
   * @minLength 10
   */
  cause: string;
  /**
   * Идентификатор автора identity
   * @format int32
   */
  id: number;
}

export interface MaterialsTopauthorsListParams {
  /** @format date-time */
  VotesPeriodFrom?: string;
  /** Тип сортировки экпсертов */
  SortBy?: SravniNewsSharedEnumsSortExprertsType;
  Name?: string;
  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;
  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
}

export interface BackofficeCommentsListParams {
  /**
   * Начало периода
   * @format date-time
   */
  From?: string;
  /**
   * Конец периода
   * @format date-time
   */
  To?: string;
  /**
   * Идентификатор материала
   * @format int64
   */
  PostId?: number;
  /** Титул материала */
  MaterialTitle?: string;
  /**
   * Идентификатор родительского комментария
   * @format int64
   */
  ParentId?: number;
  /** Текст комментария */
  Text?: string;
  /** Имя/фамилия автора */
  UserName?: string;
  /** Почта автора */
  Email?: string;
  /** Телефон автора */
  Phone?: string;
  /** Статус премодерации */
  ModerationReasonType?: SravniNewsSharedEnumsModerationReasonType;
  /** Удален/нет */
  IsDeleted?: boolean;
  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;
  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
}

export interface CommentsListParams {
  /**
   * Идентификатор материала
   * @format int64
   */
  PostId: number;
  /**
   * Идентификатор родительского комментария
   * @format int64
   */
  ParentId?: number;
  /**
   * Если нужно пропустить какое-то конкретное число комментариев вместо постраничной выдачи
   * @format int32
   */
  Skip?: number;
  /** Тип сортировки комментария */
  SortBy?: SravniNewsSharedEnumsCommentsSortBy;
  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;
  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
  fingerPrint?: string;
}

export interface CommentsAuthorDetailParams {
  /** Сортировать ли дату создания коммента по убыванию? */
  SortByCreatedDateDesc?: boolean;
  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;
  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
  /**
   * Идентификатор автора identityId
   * @format int32
   */
  id: number;
}

export interface CommentsCountListParams {
  /**
   * Идентификатор статьи
   * @maxItems 50
   */
  postIds?: number[];
}

export interface TagsListParams {
  /** Полное или частичное наименование тэга */
  term?: string;
}

export interface DictionaryListParams {
  type?: SravniNewsSharedEnumsDictionaryType;
}

export interface RubricsListParams {
  /** Места подмешивания продвигаемых новостей */
  placement?: SravniNewsSharedEnumsPlacementType;
  includePrivate?: boolean;
  ignoreMenuOrder?: boolean;
}

export interface RubricTagsListParams {
  rubric:
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta';
}

export interface FeedsListParams {
  feedType?:
    | 'tinkoff-invest'
    | 'yandex-news'
    | 'yandex-zen'
    | 'yandex-search'
    | 'pulse'
    | 'vmetro'
    | 'google-news'
    | 'vkontakte'
    | 'rambler'
    | 'instagram';
  rubricAlias?: string[];
  tagAlias?: string[];
  subTagAlias?: string[];
}

export interface AdditionalReadingHighlightsListParams {
  /** Alias самого свежего материала, используется для получения материалов с датой публикации ДО даты запрошенного материала */
  Alias?: string;
  IsWebFlow?: boolean;
  TinkoffInvestments?: boolean;
  Vmetro?: boolean;
  MostInteresting?: boolean;
  IsPreview?: boolean;
  IsYandexZen?: boolean;
  OrderBy?: SravniNewsSharedModelsMaterialsOrderBy;
  IncludeExternal?: boolean;
  /** @format int32 */
  MinimalViewsFrom?: number;
  /** Признак, что статья сгенерирована нейросетью */
  IsAi?: boolean;
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  SubTags?: string[];
  Rubrics?: (
    | 'all'
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
    | 'rko'
    | 'biznes-kredity'
    | 'biznes-accounting'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  /** Места подмешивания продвигаемых новостей */
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface ExternalMaterialsListParams {
  /** Alias самого свежего материала, используется для получения материалов с датой публикации ДО даты запрошенного материала */
  Alias?: string;
  IsWebFlow?: boolean;
  TinkoffInvestments?: boolean;
  Vmetro?: boolean;
  MostInteresting?: boolean;
  IsPreview?: boolean;
  IsYandexZen?: boolean;
  OrderBy?: SravniNewsSharedModelsMaterialsOrderBy;
  IncludeExternal?: boolean;
  /** @format int32 */
  MinimalViewsFrom?: number;
  /** Признак, что статья сгенерирована нейросетью */
  IsAi?: boolean;
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  SubTags?: string[];
  Rubrics?: (
    | 'all'
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
    | 'rko'
    | 'biznes-kredity'
    | 'biznes-accounting'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  /** Места подмешивания продвигаемых новостей */
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface MaterialsPopularHighlightsListParams {
  /**
   * Количество новостей на страницу
   * @format int32
   */
  Limit?: number;
  /** Плейсмент */
  Placement?: SravniNewsSharedEnumsPlacementType;
  /** Рубрика. Приватные и прессрелиз запрещены */
  Rubric?:
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta';
  /** Рубрики (если нужно фильтровать сразу по нескольким). Приватные и прессрелиз запрещены */
  Rubrics?: (
    | 'all'
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta'
  )[];
  /**
   * Лимит плейсмент материалов в выдаче
   * @format int32
   */
  PlacementLimit?: number;
}

export interface MaterialsHighlightsListParams {
  /** Рубрика, если Undefined, то только статьи */
  Rubric?:
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta';
  /** Плейсмент */
  Placement?: SravniNewsSharedEnumsPlacementType;
  /** Отдавать контент статьи или нет, по умолчанию контент статьи отдается */
  IncludeBody?: boolean;
  /**
   * Дата, по которую ограничивать данные
   * @format date-time
   */
  DateTo?: string;
  /** Набор тегов */
  Tags?: string[];
  /** Набор подтегов */
  SubTags?: string[];
  /**
   * 0-bazed "страница" новостей
   * (считаем страницу с нуля)
   * @format int32
   */
  Page?: number;
  /**
   * Количество новостей на страницу
   * @format int32
   */
  Limit?: number;
}

export interface MaterialsHighlightsNewsListParams {
  /**
   * 0-bazed "страница" новостей
   * (считаем страницу с нуля)
   * @format int32
   */
  Page?: number;
  /**
   * Количество новостей на страницу
   * @format int32
   */
  Limit?: number;
}

export interface MaterialsAuthorDetailParams {
  /** Текст для поиска */
  Text?: string;
  /** @format int32 */
  Limit?: number;
  /** @format int32 */
  Skip?: number;
  /** Тип материала */
  MaterialType?: SravniNewsSharedEnumsMaterialType;
  /** Теги */
  Tags?: string[];
  /** Подтеги */
  SubTags?: string[];
  /** Сортировка */
  OrderBy?: SravniNewsSharedModelsMaterialsOrderBy;
  /** @format int32 */
  userId: number;
}

export interface MaterialsOrganizationHighlightsListParams {
  OrganizationIds?: string[];
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  SubTags?: string[];
  Rubrics?: (
    | 'all'
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
    | 'rko'
    | 'biznes-kredity'
    | 'biznes-accounting'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  /** Места подмешивания продвигаемых новостей */
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface HeadV12Params {
  /**
   * @format int64
   * @default 0
   */
  entityId?: number;
  /** @format int64 */
  postId: number;
}

export interface LikesCountListParams {
  postIds?: number[];
}

export interface LikesDeleteParams {
  /**
   * Идентификатор поста
   * @format int64
   * @min 0
   * @max 2147483647
   */
  PostId?: number;
  /**
   * Идентификатор коммента, 0 если лайк присвоен исключительно посту
   * @format int64
   * @min 0
   * @max 2147483647
   */
  EntityId?: number;
  /** FP пользователя */
  FingerPrint?: string;
}

export interface UserSelfLikesListParams {
  fingerPrint?: string;
}

export interface MaterialsPopularListParams {
  /**
   * Количество новостей на страницу
   * @format int32
   */
  Limit?: number;
  /** Плейсмент */
  Placement?: SravniNewsSharedEnumsPlacementType;
  /** Рубрика. Приватные и прессрелиз запрещены */
  Rubric?:
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta';
  /** Рубрики (если нужно фильтровать сразу по нескольким). Приватные и прессрелиз запрещены */
  Rubrics?: (
    | 'all'
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta'
  )[];
  /**
   * Лимит плейсмент материалов в выдаче
   * @format int32
   */
  PlacementLimit?: number;
}

export interface MaterialsListParams {
  /** Alias самого свежего материала, используется для получения материалов с датой публикации ДО даты запрошенного материала */
  Alias?: string;
  IsWebFlow?: boolean;
  TinkoffInvestments?: boolean;
  Vmetro?: boolean;
  MostInteresting?: boolean;
  IsPreview?: boolean;
  IsYandexZen?: boolean;
  OrderBy?: SravniNewsSharedModelsMaterialsOrderBy;
  IncludeExternal?: boolean;
  /** @format int32 */
  MinimalViewsFrom?: number;
  /** Признак, что статья сгенерирована нейросетью */
  IsAi?: boolean;
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  SubTags?: string[];
  Rubrics?: (
    | 'all'
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
    | 'rko'
    | 'biznes-kredity'
    | 'biznes-accounting'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  /** Места подмешивания продвигаемых новостей */
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface MaterialsSingleListParams {
  Alias: string;
  /** @format date-time */
  Created?: string;
  Unpublished?: boolean;
  IsWebFlowOnly?: boolean;
}

export interface MaterialsInfoListParams {
  /**
   * Дата начала периода. По умолчанию: текущий день (UTC+0)-14 дней
   * @format date-time
   */
  From?: string;
  /**
   * Дата окончания периода. По умолчанию: текущий день (UTC+0)
   * @format date-time
   */
  To?: string;
}

export interface MaterialsOpensearchSearchListParams {
  /** Текст который ищем в материале */
  Term?: string;
  /**
   * Нижняя граница поиска
   * @format date-time
   */
  DateFrom?: string;
  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;
  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
}

export interface OrganizationsInfoListParams {
  /** @default false */
  activeOnly?: boolean;
}

export interface MaterialsOrganizationListParams {
  OrganizationIds?: string[];
  /** @format int32 */
  Take?: number;
  /** @format int32 */
  Skip?: number;
  /** @format int32 */
  PageIndex?: number;
  Tags?: string[];
  SubTags?: string[];
  Rubrics?: (
    | 'all'
    | 'lgoty'
    | 'sportivnye-stati'
    | 'sportivnye-eksperty'
    | 'sportivnyeprognozy'
    | 'obrazovanie'
    | 'novosti'
    | 'novosti-partnerov'
    | 'putevoditel'
    | 'specproekty'
    | 'biznes'
    | 'pravo'
    | 'auto'
    | 'vklady'
    | 'karty'
    | 'kredity'
    | 'investicii'
    | 'nedvizhimost'
    | 'strahovki'
    | 'sovety'
    | 'analitika'
    | 'produkty'
    | 'sravnenija'
    | 'testdrajvy'
    | 'sport'
    | 'novosti-sporta'
  )[];
  Products?: (
    | 'debetovye-karty'
    | 'vzr'
    | 'ipoteka'
    | 'karty'
    | 'MortgageCreditRefinancing'
    | 'vklady'
    | 'kredity'
    | 'avtokredity'
    | 'osago'
    | 'dms'
    | 'kasko'
    | 'strahovanie-ns'
    | 'PropertyInsuranceHousing'
    | 'CurrencyCard'
    | 'PropertyInsuranceSummerHouse'
    | 'CashCredit'
    | 'InvestmentSaving'
    | 'MoneyTransfer'
    | 'valjuty'
    | 'CreditRefinancing'
    | 'zaimy'
    | 'MicrocreditWithBadCreditHistory'
    | 'WithRenewalSaving'
    | 'ShopCard'
    | 'strahovanie-nedvizhimosti'
    | 'strahovanie-ipoteki'
    | 'BankCurrency'
    | 'TrafficFines'
    | 'EducationCredit'
    | 'PensionarySaving'
    | 'StudentCard'
    | 'CashWithdrawalCard'
    | 'CoBrandingCard'
    | 'ChildrenSaving'
    | 'OnlineMicrocredit'
    | 'CreditForRepair'
    | 'TravelCard'
    | 'CardWithInterestOnBalance'
    | 'CarBrand'
    | 'Car'
    | 'PensionaryCard'
    | 'CardWithoutCommission'
    | 'Card'
    | 'OnlineOsago'
    | 'ConsumerCredit'
    | 'ProfitableCard'
    | 'InterestRateCard'
    | 'CardByTwoDocuments'
    | 'GracePeriodCard'
    | 'CreditLimitCard'
    | 'MortgageForYangFamily'
    | 'BanksRatingByDeposits'
    | 'WithoutSolvencyProofCard'
    | 'CreditOnTheSameDay'
    | 'BanksRatingByAssets'
    | 'MonthlyPaymentAutoCredit'
    | 'AutoCreditByTwoDocuments'
    | 'CardByPost'
    | 'MonthlyPaymentMortgage'
    | 'GreenCard'
    | 'mortgagewithnodownpayment'
    | 'MonthlyPaymentCredit'
    | 'MulticurrencySaving'
    | 'debetcard'
    | 'FreeCard'
    | 'MonthlyPaymentSaving'
    | 'FundWithdrawalSaving'
    | 'AutoCreditForUsedVehicle'
    | 'DemandSaving'
    | 'WithoutSolvencyProofCredit'
    | 'SeasonedSaving'
    | 'PropertyInsuranceForRent'
    | 'MortgageCreditForRealEstateInPrimaryMarket'
    | 'BanksRatingByCredits'
    | 'TimeSaving'
    | 'PropertyInsuranceZalogovogoImushhestva'
    | 'PropertyInsuranceBathhouse'
    | 'zaimy-2'
    | 'kredity-onlajn-zayavka-na-kredit'
    | 'zaimy-onlain'
    | 'onlajn-zayavka-na-kredit'
    | 'brokerskoe-obsluzhivanie'
    | 'ege-oge'
    | 'bankovskie-garantii'
    | 'strahovka-ot-klescha'
    | 'ekvajring'
    | 'rating'
    | 'strahovka-kriticheskie-bolezni'
    | 'biznes-registration'
    | 'biznes-leasing'
    | 'biznes-vklady'
    | 'biznes-marketplace'
    | 'zarplatnyj-proekt'
    | 'ved'
    | 'bankrotstvo'
    | 'strahovanie-domov'
    | 'kursy'
    | 'rko'
    | 'biznes-kredity'
    | 'biznes-accounting'
  )[];
  ExcludedIds?: number[];
  /** @format date-time */
  DateFrom?: string;
  /** @format date-time */
  DateTo?: string;
  /** Места подмешивания продвигаемых новостей */
  Placement?: SravniNewsSharedEnumsPlacementType;
}

export interface OrganizationsPartnersInfoListParams {
  /**
   * @format int32
   * @default 6
   */
  take?: number;
  /**
   * @format int32
   * @default 7
   */
  activityDays?: number;
}

export interface ActivityByServiceDetailParams {
  /**
   * Номер страницы
   * @format int32
   */
  PageIndex?: number;
  /**
   * Размер страницы
   * @format int32
   */
  PageSize?: number;
  /** @format int32 */
  id: number;
}

export interface ViewsCountListParams {
  postIds?: number[];
}
